import type { ComponentType, PropsWithChildren, ReactElement } from 'react';
import type React from 'react';
import { Suspense, lazy } from 'react';
import { yieldToMain } from 'tradera/utils/scheduler';

const RenderChildren = ({ children }: PropsWithChildren): ReactElement => (
    <>{children}</>
);

const Yield = lazy(
    async (): Promise<{ default: ComponentType<PropsWithChildren> }> => {
        await yieldToMain();

        return {
            default: RenderChildren
        };
    }
);

export const RenderAsync = ({ children }: React.PropsWithChildren) => (
    <Suspense fallback={null}>
        <Yield>{children}</Yield>
    </Suspense>
);
